<template>
  <div>
    <AppLoggedAs/>
    <div class="mobile-display">
    </div>
    <b-container class="maintenance">
      <h1 id="maintenance-title" class="pb-1 mb-4 text-white text-uppercase font-weight-bold">
        {{$t($getConst.pages.maintenance.maintenance, this.$store.getters["auth/scopeDefault"].language_id.code)}}
      </h1>
      <h2 id="maintenance-sub-title" class="pb-1 mb-1 text-white text-uppercase font-weight-bold">
        {{$t($getConst.pages.maintenance.maintenance_message_+$store.getters["auth/scopeDefault"].name , this.$store.getters["auth/scopeDefault"].language_id.code)}}
      </h2>

    </b-container>

    <AppConfirmButtons
      variant="primary small-btn"
      no-cancel
      :submit-text="this.$getConst.pages.settings.sign_out"
      :is-disabled="$store.getters['auth/isLoggedAs']"
      @onSubmit="logout"
    />

  </div>
</template>

<script>
  import AppConfirmButtons from "../../components/common/utils/AppConfirmButtons";
  import AppLoggedAs from "../../components/layout/AppLoggedAs";
  export default {
    name: "Maintenance",
    components: {AppLoggedAs, AppConfirmButtons},
    methods: {
      logout() {
        this.$store.dispatch("auth/logout");
      }
    }
  }
</script>

<style scoped>

</style>
